import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@aichat/ui/components/ui/carousel";
import { ChevronLeft, ChevronRight } from "lucide-react";
import useCarouselApi from "@aichat/ui/hooks/useMainCarouselApi";

import { cn } from "@aichat/ui/lib/utils";
import { ProductCarouselComponent as TProductCarouselComponent } from "@aichat/types/socket/widget.types";
import ProductCarouselComponent from "./product-carousel-component";

type ProductCarouselListComponentProps = {
  type?: "portal-chat" | "widget-chat";
  isUser?: boolean;
  productCarousels: TProductCarouselComponent[];
};

function ProductCarouselListComponent({
  productCarousels,
  type,
}: ProductCarouselListComponentProps) {
  const { setMainCarouselApi, canScrollPrev, canScrollNext } = useCarouselApi();

  return (
    <Carousel
      setApi={setMainCarouselApi}
      className={cn(" w-full  ", {
        "justify-end": type === "portal-chat",
      })}
    >
      <CarouselContent
        className={cn(
          "w-full -ml-4  ",
          productCarousels.length == 1 ? "flex-row-reverse" : "flex-row",
        )}
      >
        {productCarousels.map((component, idx) => (
          <CarouselItem
            key={component.url ? component.url : idx}
            className={cn(
              "@sm/product-carousel:basis-1/2",
              productCarousels.length > 2
                ? " @lg/product-carousel:basis-1/3"
                : " @lg/product-carousel:basis-1/2",
            )}
          >
            <ProductCarouselComponent {...component} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious
        icon={<ChevronLeft />}
        className={cn(" left-[10px]", {
          hidden: !canScrollPrev,
        })}
      />
      <CarouselNext
        icon={<ChevronRight />}
        className={cn(" right-[10px]", {
          hidden: !canScrollNext,
        })}
      />
    </Carousel>
  );
}

export default ProductCarouselListComponent;
